<div #divMenu id="mu-popup-menu" class="mu-popup-menu-position-{{ position }}">
  <p-menu #menu [popup]="true" [model]="menuList" appendTo="body"></p-menu>
  <i class="fas fa-ellipsis-v" (click)="menu.toggle($event)" aria-hidden="true"></i>
</div>
